"use client";

import { HmcTag } from "@adi-ctx/harmonic-core-components-react";
import { t } from "@/utils";

type DriverStatusProps = {
	readonly isObsolete: boolean;
};

// Display a status Tag component for the drivers
export default function DriverStatus({ isObsolete }: DriverStatusProps) {
	return (
		<div className="xs:w-[300px] w-[110px] md:w-[110px]">
			<HmcTag
				isFullWidth
				withIcon
				size="md"
				emphasis="subtle"
				status={isObsolete ? "warning" : "success"}
				data-testid={`driver-status--${isObsolete ? "obsolete" : "active"}`}
			>
				{t(`drivers-list.status-${isObsolete ? "obsolete" : "active"}`)}
			</HmcTag>
		</div>
	);
}
